import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { IModule } from 'redux-state/layout/types.js';

interface IExternalContentLoader {
  url: string;
}

const ExternalContentLoader = (props: IModule<IExternalContentLoader>) => {
  const {
    config: { url },
  } = props;

  return (
    <Tile dataModule="external-content-loader" {...props}>
      <div className="Tile-body">
        <TileBodyHeaderV2 {...props} />
        <div className="ExternalContent-wrapper ">
          <iframe src={url} />
        </div>
      </div>
    </Tile>
  );
};

export { ExternalContentLoader };
